import { FC, memo } from 'react';

import { propsAreEqual } from '../../../../../util';
import PlanogramGridList from './components/PlanogramGridList/PlanogramGridList';
import PlanogramTableList from './components/PlanogramTableList/PlanogramTableList';

import './PlanogramProjectItemsList.less';

interface PlanogramItemsListProps {
  skeletonItemLength?: number;
  projects: any[];
  loading: boolean;
  onLoadMore: () => void;
  hasMore: boolean;
  viewType: PlanogramItemsListViewType;
  onItemClick?: (projectId: string) => void;
}

export enum PlanogramItemsListViewType {
  Grid = 'grid',
  Table = 'table',
}

const PlanogramProjectItemsList: FC<PlanogramItemsListProps> = (props) => {
  const {
    projects,
    loading,
    onLoadMore,
    hasMore,
    viewType,
    skeletonItemLength,
    onItemClick,
  } = props;

  return viewType === PlanogramItemsListViewType.Grid ? (
    <PlanogramGridList
      skeletonItemLength={skeletonItemLength}
      loading={loading}
      projects={projects}
      onLoadMore={onLoadMore}
      hasMore={hasMore}
      onItemClick={onItemClick}
    />
  ) : (
    <PlanogramTableList
      loading={loading}
      projects={projects}
      onItemClick={onItemClick}
    />
  );
};

export default memo(PlanogramProjectItemsList, propsAreEqual);
